import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const coc_signed = ({ event: { kind, data } }) =>
  <div className={kind}>
    COC signed by {data.signee}
  </div>;


coc_signed.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({}).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/coc_signed.jsx